/**
 * Backend URL: on Vercel (production or preview) always use Railway; otherwise use env or localhost.
 * Set REACT_APP_BACKEND_URL in .env or Vercel for a different backend; changing RAILWAY_BACKEND_URL
 * below requires a frontend redeploy unless you use env for production.
 */
const RAILWAY_BACKEND_URL = "https://reflect-app-production.up.railway.app";

export function getBackendUrl() {
  if (typeof window !== "undefined" && (window.location?.hostname?.includes("vercel.app") || window.location?.hostname === "app.ireflect.app")) {
    return RAILWAY_BACKEND_URL;
  }
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
  }
  return "http://localhost:8000";
}
